import { CustomReportConfig, LineChartModule } from "@/component/common/report/reportConfigModel"
import { QuickBiReportDataResponse } from "../services/bi/bi"
import { isError } from "@/component/common/error"
import { serviceQuickBiReportTemplate } from "@/component/Template/services/template"
import { TemplateDataModel } from "@/component/Template/TemplateDataModel"
import React from "react"
import { useUpdateEffect} from 'ahooks'

// import { Chart } from '@antv/g2';
import _ from "lodash"
import { ReportConfig,ReportParams } from "@/component/common/report/report"


const formatLineCartData = (data: Record<string,string|number>[],cartType:LineChartModule['cartType'],templateFields:{[field:string]:Required<TemplateDataModel>['fields'][0]})=>{
  cartType.forEach((item)=>{
    let yArray = item.y?.fields || []
      data = data.map(dataItem =>{
        yArray.forEach((yItem)=>{
          dataItem[yItem.field] = Number(dataItem[yItem.field])
          let title = getTempalteFieldTitle(templateFields,yItem.field)
          dataItem[title] =  dataItem[yItem.field]
        })
        return dataItem
      })
  })
  return data
}


interface CustomLineChartProps {
  reportConfig: ReportConfig,
  moduleItem: LineChartModule,
  params: ReportParams
  // reportData: QuickBiReportDataResponse
  reportTableData?:Array<Record<string,string|number>>
}

const getTempalteFieldTitle = (templateFields:{[field:string]:Required<TemplateDataModel>['fields'][0]},field:string)=>{
  return templateFields[field] && templateFields[field].title || field
}


export function CustomLineChart(props: CustomLineChartProps) {
  const { reportConfig, moduleItem, params,reportTableData } = props
  const { cartType } = moduleItem
  const [template, setTemplate] = React.useState<TemplateDataModel>()
  const chartRef =  React.useRef<any>()
  const templateFields = React.useMemo(()=>{
    return  _.keyBy(template?.fields || [],'code')
  },[template]);
  const renderLineChart = (data:Record<string,string|number>[])=>{
    data = formatLineCartData(data,cartType,templateFields)
    // const chart = new Chart({
    //   container: document.querySelector('.line-cahrt') as HTMLElement,
    //   height:380,
    //   autoFit:true
    // });
    // console.log(data)
    // chartRef.current = chart
    let lineChart = cartType.find((item)=>item.type == 'line')
    let intervalChart = cartType.find((item)=>item.type == 'interval')
    let INTERVAL_VALUE = 'INTERVAL_VALUE'
    let INTERVAL_KEY = 'INTERVAL_KEY'
    let LINE_VALUE = 'LINE_VALUE'
    let LINE_KEY = 'LINE_KEY'


    // chart.axis('x', {
    //   title: title,
    //   titleFill: lineChart.x?.titleFill,
    // })
    // chart.interaction('elementHighlight', { background: true });
    if(intervalChart){
      let xKey = intervalChart.x?.field || ''
      let title = templateFields[xKey] && templateFields[xKey].title || ''
      let yFields = intervalChart.y?.fields ||[]
      let titleFill = intervalChart.x?.titleFill

      // yFields.forEach(item=>{
      //   let title =  getTempalteFieldTitle(templateFields,item.field)
      //   chart.interval()
      //   .encode('x',xKey)
      //   .encode('y',title)
      //   .encode('color', ()=>title)
      //   .encode('series', () => title)
      //   // .encode('color', item.field)
      //   // .transform({ type: 'dodgeX' })
      //   // .axis('y', {
      //   //   position: 'right',
      //   //   title: title,
      //   //   titleFill: titleFill,
      //   // })
      // })
      // chart.axis('x', {
      //   title: title,
      //   titleFill: intervalChart.x?.titleFill,
      // })
      // chart.axis('y', {
      //   position: 'left',
      //   title: intervalChart.y?.title,
      //   titleFill: intervalChart.y?.titleFill,
      // })

      // chart.axis('y',{
      //     position: 'right',
      //     title: '123123',
      //     titleFill: titleFill,
      // })
      // .scale('y', { key: '2' })
      // .scale('y', { independent: true })

      // .scale('y', { independent: true })

      // chart.interval()
      // .encode('x',intervalChart.x?.field)
      // .encode('y',INTERVAL_VALUE)
      // .encode('color', INTERVAL_KEY)
      // .transform({ type: 'dodgeX' })
      // .axis('y', {
      //   position: 'right',
      //   title: title,
      //   titleFill: intervalChart.x?.titleFill,
      // })
      // // .axis('y', {
      // //   position: 'right',
      // //   title: title,
      // //   titleFill: '#5470C6',
      // // })
      // .scale('y', { independent: true })
    }
    console.log(templateFields)
    if(lineChart){
      let xKey = lineChart.x?.field || ''
      let title = templateFields[xKey] && templateFields[xKey].title || ''
      let yFields = lineChart.y?.fields ||[]
      let titleFill = lineChart.x?.titleFill
      lineChart.y     
 
      yFields.forEach(item=>{
        let title =  getTempalteFieldTitle(templateFields,item.field)
      //   chart.line()
      //     .encode('x', xKey)
      //     .encode('y',title)
      //     .encode('color',()=> title)
      //     .scale('series', { independent: true })

      //     // .encode('series', () => item.field)
      //     // .scale('y', { independent: true })
      //     // .transform({ type: 'dodgeX' })
         
      //     // .axis('y', {
      //     //   position: 'left',
      //     //   title: title,
      //     //   titleFill: lineChart.x?.titleFill,
      //     // });
      // })
      // chart.axis('y', {
      //   position: 'left',
      //   title: lineChart.y?.title,
      //   titleFill: lineChart.y?.titleFill,
      // })
      // .axis('x', {
      //   title: title,
      //   titleFill: lineChart.x?.titleFill,
      })

      // .scale('y', { independent: true })

      // chart.line()
      // .encode('x',lineChart.x?.field)
      // .encode('y',LINE_VALUE)
      // .encode('color', LINE_KEY)
      // .scale('y', { independent: true })
      // // .transform({ type: 'dodgeX' })
      // .axis('x', {
      //   title: title,
      //   titleFill: lineChart.x?.titleFill,
      // })
      // .axis('y', {
      //   position: 'left',
      //   title: title,
      //   titleFill: lineChart.x?.titleFill,
      // });
    }
    // function foldData(data:any[],cartType:LineChartModule['cartType']){
    //   // let transform:any[] = [] 
    //   // cartType.forEach(item=>{
    //   //   let yArray = item.y?.fields || []
    //   //   let fields = yArray.map((yItem)=>yItem.field)
    //   //   if(item.type == 'interval'){
    //   //     transform.push({
    //   //       type: 'fold',
    //   //       fields,
    //   //       key: INTERVAL_KEY,
    //   //       value: INTERVAL_VALUE,
    //   //     })
    //   //   }
    //   //   if(item.type == 'line'){
    //   //     transform.push({
    //   //       type: 'fold',
    //   //       fields,
    //   //       key: LINE_KEY,
    //   //       value: LINE_VALUE,
    //   //     })
    //   //   }
    //   // })
    //   // chart.data({
    //   //   type: 'inline',
    //   //   value: data,
    //   //   transform: transform,
    //   // });
    //   chart.data(data)
    // }
    // foldData(data,cartType)
    // let fields = cartType.reduce<string[]>((preValue,item)=>{
    //   let yArray = item.y || []
    //   let fields = yArray.map((yItem)=>yItem.field)
    //   return Array.from(new Set([...fields,...fields]))
    // },[])
    // chart.data({
    //   type: 'inline',
    //   value: data,
    //   transform:[
    //     {
    //       type: 'fold',
    //       fields: fields,
    //       key: KEY,
    //       value: VALUE,
    //     }
    //   ],
    // });
   
    // chart.render();
  }
  const getTemplate = async () => {
    let template = await serviceQuickBiReportTemplate({ report: reportConfig.config.slug, template_code: moduleItem.template_code });
    if (isError(template)) {
      return
    }
    setTemplate(template.data)
    renderLineChart(reportTableData ||[])
    // console.log(template)
    // let data = await getQuickBiReportData(params)
    // if (isError(data)) {
    //   return
    // }
    // console.log(data)
    // setReportData(data.data)
  }
  
  React.useEffect(() => {
    getTemplate()
    return ()=>{
      chartRef.current?.destroy()
    }
  },[])
  useUpdateEffect(()=>{
    if(reportTableData && template){
      chartRef.current?.destroy()
      renderLineChart(reportTableData ||[])
    }
   

    // let data = reportData.listsData || []
    // data = formatLineCartData(data, cartType)
    // chartRef.current?.data(data)
  },[reportTableData,template])
  return <div className="line-cahrt" style={{minHeight:'380px'}}></div>
}

